import { useEffect, useState } from "react";
import { localeNames, supportedLocales } from "../i18n/locales";

function localeHref(locale, page) {
  return page === "gecko" ? `/${locale}/gecko/` : `/${locale}/`;
}

const BRAND_ARIA = {
  fr: "imajnet web geo services par Imajing",
  en: "imajnet web geo services by Imajing",
  es: "imajnet web geo services por Imajing",
};

export function SiteHeader({ locale, page, copy, navigation }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const brandAria = BRAND_ARIA[locale] || BRAND_ARIA.en;

  useEffect(() => {
    if (!menuOpen) return undefined;

    const closeOnEscape = (event) => {
      if (event.key === "Escape") setMenuOpen(false);
    };

    document.body.classList.add("menu-open");
    document.addEventListener("keydown", closeOnEscape);

    return () => {
      document.body.classList.remove("menu-open");
      document.removeEventListener("keydown", closeOnEscape);
    };
  }, [menuOpen]);

  return (
    <>
      <header className={`site-header ${page}-header`}>
        <a
          className="header-brand"
          href={`https://www.imajing.eu/?utm_source=imajnet.net&utm_medium=referral&utm_campaign=${locale}_header_brand`}
          aria-label={brandAria}
        >
          <strong>imajnet® web geo services</strong>
          <span> - by </span>
          <em>imajing</em>
        </a>
        <div className="header-actions">
          <nav className="language-nav" aria-label="Language">
            {supportedLocales.map((item) => (
              <a
                className={item === locale ? "active" : ""}
                href={localeHref(item, page)}
                hrefLang={item}
                key={item}
              >
                {localeNames[item]}
              </a>
            ))}
          </nav>
          {page === "gecko" ? (
            <a className="menu-trigger" href={`/${locale}/`}>
              {copy.home}
            </a>
          ) : (
            <button
              aria-controls="tools-menu"
              aria-expanded={menuOpen}
              className="menu-trigger"
              onClick={() => setMenuOpen(true)}
              type="button"
            >
              <span className="menu-icon" aria-hidden="true">
                <i />
                <i />
                <i />
              </span>
              {copy.menu}
            </button>
          )}
        </div>
      </header>

      {page === "home" && (
        <>
          <button
            aria-label={copy.close}
            className={`menu-backdrop${menuOpen ? " visible" : ""}`}
            onClick={() => setMenuOpen(false)}
            type="button"
          />
          <aside
            aria-hidden={!menuOpen}
            className={`tools-menu${menuOpen ? " visible" : ""}`}
            id="tools-menu"
          >
            <button
              aria-label={copy.close}
              className="menu-close"
              onClick={() => setMenuOpen(false)}
              type="button"
            >
              &times;
            </button>
            <nav aria-label={copy.menu}>
              {navigation.map((item) => (
                <a href={item.href} key={item.href} onClick={() => setMenuOpen(false)}>
                  {item.label}
                </a>
              ))}
            </nav>
          </aside>
        </>
      )}
    </>
  );
}
